var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("ul.timeline {\n  list-style-type: none;\n  position: relative;\n}\nul.timeline:before {\n  content: \" \";\n  background: #d4d9df;\n  display: inline-block;\n  position: absolute;\n  left: 29px;\n  width: 2px;\n  height: 100%;\n  z-index: 400;\n}\nul.timeline > li {\n  margin: 20px 0;\n  padding-left: 20px;\n}\nul.timeline > li:before {\n  content: \" \";\n  background: white;\n  display: inline-block;\n  position: absolute;\n  border-radius: 50%;\n  border: 3px solid #22c0e8;\n  left: 20px;\n  width: 20px;\n  height: 20px;\n  z-index: 400;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return (0, _defineProperty3.default)({
      modal_name: "trackerModal",
      modal_target: "#trackerModal",
      invoice_id: null,
      invoice_number: null,
      amount_settled_offline: null,
      amount_expected: null,
      amount_paid: null,
      invoice_status: null,
      invoice_retries: null,
      invoice: null,
      inserted_at: null,
      payment_date: null,
      invoice_payment_complete: null,
      invoice_payment_partial: null,
      invoice_payment_settled: null,
      is_notification_sent: null
    }, "invoice_status", null);
  },

  mounted: function mounted() {
    this.modal_name = this.modal_name + "_" + this.$attrs["id"];
    this.modal_target = this.modal_target + "_" + this.$attrs["id"];
    this.invoice = JSON.parse(this.$attrs["invoice"]);
    this.invoice_number = this.invoice["invoice_number"];
    this.is_notification_sent = this.invoice["confirmed?"];
    this.amount_paid = this.invoice["amount_paid"];
    this.amount_expected = this.invoice["amount_expected"];
    this.amount_settled_offline = this.invoice["amount_settled_offline"];
    this.invoice_retries = this.invoice["retries"];
    this.invoice_status = this.invoice["status"];
    this.inserted_at = this.format_date(this.invoice["inserted_at"]);
    this.payment_date = this.format_date(this.invoice["payment_date"]);
    this.invoice_status = this.invoice["status"];
    this.diagnose();
  },
  methods: {
    format_date: function format_date(date) {
      if (date == null) {
        return "";
      }
      return (0, _moment2.default)(date).format("ddd Do MMMM, YYYY");
    },
    diagnose: function diagnose() {
      if (parseFloat(this.amount_paid) == parseFloat(this.amount_expected)) {
        this.invoice_payment_complete = true;
      }
      if (parseFloat(this.amount_paid) > 0 && parseFloat(this.amount_paid) < parseFloat(this.amount_expected)) {
        this.invoice_payment_partial = true;
      }
      if (this.invoice_status == "settled") {
        this.invoice_payment_settled = !false;
      } else {
        this.invoice_payment_settled = false;
      }
      if (this.is_notification_sent == "true") {
        this.is_notification_sent = !false;
      } else {
        this.is_notification_sent = !false;
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"javascript:void(0)","data-toggle":"modal","data-target":_vm.modal_target}},[_vm._v("Track")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":_vm.modal_name,"tabindex":"-1","role":"dialog","aria-labelledby":"trackerModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Track Results for Invoice "+_vm._s(_vm.invoice_number))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Invoice Timeline")]),_vm._v(" "),_c('ul',{staticClass:"timeline"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Invoice Created")]),_vm._v(" "),_c('a',{staticClass:"float-right",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.inserted_at))]),_vm._v(" "),_c('p',[_vm._v("Invoice was created")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Invoice Payment")]),_vm._v(" "),_c('a',{staticClass:"float-right",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.payment_date))]),_vm._v(" "),(_vm.invoice_payment_complete)?_c('p',{staticClass:"alert alert-success"},[_vm._v("Invoice was paid")]):_vm._e(),_vm._v(" "),(!_vm.invoice_payment_complete && !_vm.invoice_payment_partial)?_c('p',{staticClass:"alert alert-info"},[_vm._v("Invoice has not been paid")]):_vm._e(),_vm._v(" "),(_vm.invoice_payment_partial)?_c('p',{staticClass:"alert alert-warning"},[_vm._v("Invoice has been partially paid. Customer should complete payment")]):_vm._e()]),_vm._v(" "),(_vm.invoice_payment_complete)?_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Invoice Settlement")]),_vm._v(" "),(_vm.invoice_payment_settled)?_c('a',{staticClass:"float-right",attrs:{"href":"#"}}):_vm._e(),_vm._v(" "),(_vm.invoice_payment_settled)?_c('p',{staticClass:"alert alert-success"},[_vm._v("Invoice was settled...")]):_vm._e(),_vm._v(" "),(!_vm.invoice_payment_settled)?_c('p',{staticClass:"alert alert-danger"},[_vm._v("Invoice has not yet been settled...")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.invoice_payment_settled)?_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Invoice Notification")]),_vm._v(" "),(_vm.is_notification_sent)?_c('a',{staticClass:"float-right",attrs:{"href":"#"}}):_vm._e(),_vm._v(" "),(_vm.is_notification_sent)?_c('p',{staticClass:"alert alert-success"},[_vm._v("Invoice notification sent.")]):_vm._e(),_vm._v(" "),(!_vm.is_notification_sent)?_c('p',{staticClass:"alert alert-danger"},[_vm._v("Invoice notification not sent.")]):_vm._e()]):_vm._e()])])])]),_vm._v(" "),_vm._m(1)])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69f9936e", __vue__options__)
  } else {
    hotAPI.reload("data-v-69f9936e", __vue__options__)
  }
})()}